import { render, staticRenderFns } from "./InfoBadge.vue?vue&type=template&id=04b6037c&scoped=true&"
import script from "./InfoBadge.vue?vue&type=script&lang=js&"
export * from "./InfoBadge.vue?vue&type=script&lang=js&"
import style0 from "./InfoBadge.vue?vue&type=style&index=0&id=04b6037c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6037c",
  null
  
)

export default component.exports